import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=7518c87e&scoped=true&"
import script from "./Product.vue?vue&type=script&lang=js&"
export * from "./Product.vue?vue&type=script&lang=js&"
import style0 from "./Product.vue?vue&type=style&index=0&id=7518c87e&lang=scss&scoped=true&"
import style1 from "./Product.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7518c87e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7518c87e')) {
      api.createRecord('7518c87e', component.options)
    } else {
      api.reload('7518c87e', component.options)
    }
    module.hot.accept("./Product.vue?vue&type=template&id=7518c87e&scoped=true&", function () {
      api.rerender('7518c87e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/themes/default-amp/pages/Product.vue"
export default component.exports